import { Contact } from "../Contact";
import { contactDefaultValues } from "./contactDefaultValues";
import ContactFormTabs from "./ContactFormTabs";
import { useAddContact } from "../Hooks/useAddContact";

export const AddContact = () => {
  const { mutate: addContact } = useAddContact();

  return (
    <ContactFormTabs
      title="Add Contact"
      contact={contactDefaultValues}
      onSave={(it: Contact) => {
        addContact(it);
      }}
    />
  );
};
